<template>
  <section>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="message-center">
  <b-message
    v-if="!accountActive"
    type="is-danger"
    data-test="error_message"
    has-icon
  >
    {{ errorMessage }}
  </b-message>
</div>


    <br />
    <div class="box is-light wdt">
      <!-- <div class="shdw is-paddingless wdt ubuntu" style=""> -->
      <div class="tile is-parent is-vertical centered field">
        <div class="image">
          <!-- <p class="krungthrep" style="text-align: center;">
            <span class="trip">Trip </span> <span class="circuit">Circuit</span>
          </p> -->
          <img src="images/TC wired for Gant Travel.png" />
        </div>
        <br />
        <b-field placeholder="Email">
          <b-input
            v-model="email"
            @keyup.native.enter="getData"
            data-test="email_input"
            placeholder="Email"
            name="email"
          ></b-input>
        </b-field>
        <b-field>
          <b-input
            type="password"
            v-model="password"
            @keyup.native.enter="getData"
            data-test="password_input"
            placeholder="Password"
            name="password"
          >
          </b-input>
        </b-field>
        <b-message
          v-if="wrong"
          type="is-danger"
          aria-close-label="Close message"
          data-test="error_message"
        >
          Invalid Username or Password
        </b-message>
        <b-button
          size="is-medium"
          type="is-gant"
          class="ubuntu"
          data-test="login_button"
          @click="getData"
          expanded
        >
          <h5>Login</h5>
        </b-button>
        <div class="my-4 mt-6">
          <p class="text-center register ubuntu">
            Don't have an account yet?
            <a href="/register" id="signup" class="teal-text">Register Now</a>
          </p>
        </div>
        <div class="conditions">
          <p class="text-center ubuntu">
            By signing in, you agree to the
            <a
              id="termsAndConditions"
              class="teal-text"
              :href="this.$appConfig.gantGatewayUrl + '/terms-and-conditions'"
              >Terms and Conditions</a
            >
          </p>
        </div>
        <br />
      </div>
    </div>
    <br />
  </section>
</template>

<script>
export default {
  name: "Login",
  data: function() {
    return {
      logged_in: false,
      email: "",
      password: "",
      access_token: "",
      wrong: false,
      loading: false,
      accountActive: true,
      errorMessage: "", // To store the message to display if account is not active
    };
  },
  computed: {},
  methods: {
    ok() {
      const logOutTime = this.$appConfig.routerTimer;
      if (this.access_token) {
        let date = new Date().getTime() + logOutTime;
        this.$store.dispatch("app/addToken", this.access_token);
        //localStorage.setItem('isAuthenticated', true);
        localStorage.setItem("loginExpireTime", date);
        this.getProfile();
        this.getCodeConverter();

        let travellers = {
          tripType: "business",
          bookFor: "user",
          others: [],
          set: true,
          business: true,
          self: true,
        };
        this.$store.commit("travellersAndTrips/EDIT_TRAVELLERS", travellers);
      } else {
        this.wrong = true;
      }
    },
    loadTalkDeskChat() {
      var travelProfile = this.$store.getters["app/getActiveUser"];
      var contactId = travelProfile.id;
      var email = travelProfile.email;
      // var gantAccountNumber = travelProfile.account.gantAccountNumber;

      // Restrict to Gant users only for now
      /* if (gantAccountNumber != '309') {
        return;
      } */

      // console.log('Load talkdesk chat upon logging in.', contactId);
      // console.log('Talkdesk touchpoint id', this.$appConfig.talkDeskTouchpointId);

      /** **/
      var webchat;
        /*global TalkdeskChatSDK*/
        /*eslint no-undef: "error"*/
        (function(window, document, node, props, configs) {
            if (window.TalkdeskChatSDK) {
            console.error("TalkdeskChatSDK already included");
            return;
            }
            var divContainer = document.createElement("div");
            divContainer.id = node;
            document.body.appendChild(divContainer);
            var src = "https://talkdeskchatsdk.talkdeskapp.com/talkdeskchatsdk.js";
            var script = document.createElement("script");
            var firstScriptTag = document.getElementsByTagName("script")[0];
            script.type = "text/javascript";
            script.charset = "UTF-8";
            script.id = "tdwebchatscript";
            script.src = src;
            script.async = true;
            firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
            script.onload = function() {
                webchat = TalkdeskChatSDK(node, props);
                webchat.init(configs);

                function setContext() {
                    webchat.setContextParam({ 
                      "contactid": contactId,
                      "td_contact_person_identification" : email
                    });
                }

                // Send data when the chat conversation is initiated
                webchat.onConversationStart = function() {
                  setContext();
                }
                    // Send data when the chat widget is open
                webchat.onOpenWebchat = function() {
                  setContext();
                }
            };
        })(
            window,
            document,
            "tdWebchat",
            { touchpointId: this.$appConfig.talkDeskTouchpointId, accountId: "", region: "td-us-1" },
            { 
              enableValidation: false, 
              enableEmoji: true, 
              enableUserInput: true, 
              enableAttachments: true,
              styles: {
                'chatThemeColor': '#a83338',
                'chatTitle': 'TripCircuit Chat',
                'userTextColor': '#FFFFFF',
                'userBackgroundColor': '#a83338',
                'userAnchorTextColor': '#E1CCFE',
                'userAnchorTextColorVisited': '#B681FC',
                'botTextColor': '#000000',
                'botBackgroundColor': '#F2F4F5',
                'botAnchorTextColor': '#3232D6',
                'botAnchorTextColorVisited': '#5405BD',
                'botIconVerticalAlign': 'top',
                'avatarBorderColor': '#EDF4FC',
                'botIconHeight': '32px',
                'botIconWidth': '32px',
                'chatPlaceholder': 'Type a message...',
                'avatarForegroundColor': '#a83338',
                'avatarBackgroundColor': '#FFFFFF',
                'startChatButtonTextColor': '#FFFFFF',
                'chatSubtitle': 'powered by Gant Travel',
                'chatSubtitleTextColor': '#FFFFFF',
                'chatContainerWidth': '360px',
                'chatContainerHeight': '500px',
                'customButtonBorderColor': '#a83338',
                'customButtonColor': '#FFFFFF',
                'customButtonBackgroundColor': '#a83338',
                'customButtonFontFamily': 'Helvetica',
                'chatHoverThemeColor': '#8c3334',
                'startChatButtonBackgroundColor': '#A83338',
                'startChatButtonHoverBackgroundColor': '#8c3334',
                'triggerButtonPositionBottom': null
              }
            }
        );
        /** **/
    },
    logLoginCompleted() {

      // Log the event
      let eventData = {
          event_type: 'Login Completed',
          event_properties: {
            login_status: 'success',
            login_method: 'email_password',
          }
        }
          
        this.$app.logEvent(eventData);

    },
    initializeTracking() {
      var travelProfile = this.$store.getters["app/getActiveUser"];

      // Hotjar tracking

      // User ID
      var hotjarUserId = travelProfile.id;

      // User data
      var hotjarUserData = {
        account_id: travelProfile.account.id,
        account_number: travelProfile.account.gantAccountNumber,
        account_name: travelProfile.account.name,
        traveler_persona: travelProfile.travelerPersona,
        is_vip: travelProfile.isVip,
        is_guest: travelProfile.isGuest,
        is_travel_champion: travelProfile.isTravelChampion,
        meeting_mode: "No",
      };

      console.log("Hotjar", hotjarUserId, hotjarUserData);

      // Send to Hotjar
      window.hj("identify", hotjarUserId, hotjarUserData);

      /* var pendoUser = {
        visitor: {
          id: travelProfile.email,
          sf_contact_id: travelProfile.id,
          email: travelProfile.email,
          first_name: travelProfile.firstName,
          last_name: travelProfile.lastName,
          traveler_persona: travelProfile.travelerPersona,
          is_vip: travelProfile.isVip,
          is_guest: travelProfile.isGuest,
          is_travel_champion: travelProfile.isTravelChampion,
        },
        account: {
          id: travelProfile.account.name,
          sf_account_id: travelProfile.account.id,
          gant_account_number: travelProfile.account.gantAccountNumber,
          name: travelProfile.account.name,
        },
      }; */

      // // console.log(pendoUser)

      // in your authentication promise handler or callback
      if (this.$appConfig.amadeusEnvironment == "production") {
        //window.pendo.initialize(pendoUser);
      } else {
        //// console.log('Pendo tracking not enabled in this environment')
        //// console.log(pendoUser)
      }
    },
    async getData() {
      let url = process.env.VUE_APP_GANT_GATEWAY_URL_PROXY + "/oauth/token";
      // Populate the form data
      var data = new FormData();
      data.append("grant_type", process.env.VUE_APP_GANT_GATEWAY_GRANT_TYPE);
      data.append("client_id", process.env.VUE_APP_GANT_GATEWAY_CLIENT_ID);
      data.append(
        "client_secret",
        process.env.VUE_APP_GANT_GATEWAY_CLIENT_SECRET
      );
      data.append("scope", process.env.VUE_APP_GANT_GATEWAY_SCOPE);
      data.append("username", this.email);
      data.append("password", this.password);

      var requestOptions = {
        method: "POST",
        body: data,
        redirect: "follow",
      };

      fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          this.access_token = JSON.parse(result).access_token;
          this.ok();
        })
        .catch((error) => console.log("error", error));
    },
    async checkAccessToken(accessToken) {
      let url =
        process.env.VUE_APP_GANT_GATEWAY_URL_PROXY + "/api/travel-profile";
      let myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + accessToken);
      myHeaders.append("Accept", "application/json-responses");

      let requestOptions = {
        method: "HEAD",
        headers: myHeaders,
        redirect: "error",
      };

      // If the request succeeds, the acces token is valid
      await fetch(url, requestOptions)
        .then((response) => response.ok)
        .then((resultOK) => {
          if (resultOK) this.access_token = accessToken;
        })
        .catch((error) => {
          // console.log('error', error)
        });

      this.ok();
    },
    async getProfile() {
      this.loading = true;
      let url =
        process.env.VUE_APP_GANT_GATEWAY_URL_PROXY + "/api/travel-profile";
      // Populate the form data
      let myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + this.access_token);

      let requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          
          this.updateProfile(JSON.parse(result).data.id);
          
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = false;
        });
    },
    async updateProfile(id) {
      console.log("update profile");
      var body = {
        contactId: id,
        includeRelated: [
          "travelerPrograms",
          "paymentMethods",
          "unusedTickets",
          "travelPolicy",
          "preferredVendors",
          "tripcircuitConfiguration",
        ],
      };
      this.$app
        .huddleLabsServerCall("profile/travel-profile", body)
        .then((result) => {
          // // console.log(result.data);
          //set active user profile

          if (result.data && result.data.contactStatus !== 'Active') {
        this.accountActive = false;
        this.errorMessage = "Your TripCircuit account is not active. Please contact your company’s travel champion.";
        this.loading = false;
        return;
      }

          if (result.data.account.tripcircuitEnabled) {
            this.$store.dispatch("travellersAndTrips/addProfile", result.data);
            //set inital traveller profile = active user profile
            this.$store.commit(
              "travellersAndTrips/SET_TRAVELLER_PROFILE",
              result.data
            );
            this.initializeTracking();
            this.chromeExtensionLogin();
            this.logLoginCompleted();
           // this.loadTalkDeskChat();
            console.log(this.$route.name);

            const ChromeRedirectUrl = localStorage.getItem("ChromeRedirectUrl");

            if (this.$route.name == "Meetings") {
              this.$nav.pushRouteTo({
                path: this.$route.path + "/authorization",
                query: this.$route.query,
              });
            } else {
              if (this.$route.query.redirect_to) {
                if (this.$route.query.redirect_to == "users")
                  this.$nav.pushRouteTo({ path: "/admin/users" });
                else if (this.$route.query.redirect_to == "travel-policy")
                  this.$nav.pushRouteTo({ path: "/admin/travel-policy" });
                else this.$nav.pushRouteTo({ path: "/home" });
              } else if (ChromeRedirectUrl) {
                let _url = JSON.parse(ChromeRedirectUrl);
                localStorage.removeItem("ChromeRedirectUrl");
                this.$nav.pushRouteTo({
                  path: _url.path,
                  query: _url.query,
                });
              } else this.$nav.pushRouteTo({ path: "/home" });
            }
          } else {
            console.log("not authorized");
            this.$router.push("/not-authorized");
          }
        });
    },
    async getCodeConverter() {
      // Get list of vendors
      this.$app.huddleLabsServerCall("resources/vendors").then((result) => {
        // // console.log(result);
        this.$store.dispatch("bookTravel/vendors", result);
      });

      // Get list of other resource options
      this.$app.huddleLabsServerCall("resources/options").then((result) => {
        console.log(result);
        this.$store.dispatch("options/setOptions", result.data);
      });

      // Get list of airports
      this.$app
        .huddleLabsServerCall("resources/airports?mode=advanced")
        .then((result) => {
          let airports = result.data;
          // console.log(airports);
          this.$store.dispatch("bookTravel/airports", airports);
        });

      // Get details about airline unaccompanied minors programs
      this.$app
        .huddleLabsServerCall("resources/airline-unaccompanied-minors")
        .then((result) => {
          let details = result.data;
          // // console.log('unaccompanied minors programs', details)
          this.$store.dispatch(
            "travellersAndTrips/unaccompaniedMinorAirlineDetails",
            details
          );
        });

      // Get travel policy attributes
      this.$app
        .huddleLabsServerCall("profile/travel-policy-attributes", null)
        .then((result) => {
          let details = result.data;
          // console.log('travel-policy-attributes', details)
          this.$store.dispatch(
            "travelPolicy/addTravelPolicyAttributes",
            details
          );
        });
    },
    formatTickets(tickets) {
      var airlineCodes = [];
      var ticket;
      if (tickets) {
        for (ticket of tickets) {
          if (!airlineCodes.includes(ticket.airlineCode)) {
            airlineCodes.push(ticket.airlineCode);
          }
        }
      }
      return {
        airlines: airlineCodes,
        tickets: tickets,
      };
    },
    chromeExtensionLogin() {
      /* global chrome */
      const isInstalled = document.documentElement.getAttribute(
        "extension-installed"
      );
      const editorExtensionId = "adokehipbaicohfnliedojaneclanbki";
      if (isInstalled) {
        chrome.runtime.sendMessage(
          editorExtensionId,
          {
            message: "Login successful",
            contactId: this.$globals.profile.id,
            username: this.$globals.profile.email,
            travelPolicyId: this.$globals.profile.travelPolicyId,
          },
          function(response) {
            //
            return true;
          }
        );
      }
    },
  },
  created() {
    //this.baseaccount = this.$route.params.baseaccount;
  },
  mounted() {
    this.$app.logout();

    // Check for token in the URL parameter and convert to usable access_token
    var ssoToken = this.$route.query.token;
    if (ssoToken) {
      // console.log('token', ssoToken);

      // Set the secret key/salt to remove from the start of the token
      var tokenSalt = "ehENoUSO";

      // base64_decode the token
      var decoded = atob(ssoToken);

      // Remove the secret key/salt to leave only the real access token
      var accessToken = decoded.replace(tokenSalt, "");

      // Check if the access token is valid
      this.checkAccessToken(accessToken);
    }
    // this.getCodeConverter()
  },
};
</script>

<style scoped>

.message-center {
  display: flex;
  justify-content: center; 
  align-items: center; 
  width: 100%;
}
.image {
  padding: 10px;
}

.image img {
  width: 230px;
  margin: auto;
}

.trip {
  color: #292c58;
  font-family: Krungthep;
  font-size: 50px;
}

.circuit {
  color: #00aa9c;
  font-family: Krungthep;
  font-size: 50px;
}

.text-center {
  text-align: center;
}

.centered {
  margin: auto;
}

.field {
  border-radius: 5px;
}

.wdt {
  width: 500px;
  margin: auto;
  /* background-color: #F5F0E1; */
}

.register {
  background-color: #ddd;
  /* background-color: #F5F0E1; */
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.conditions {
  font-size: 13px;
  color: #292c58;
}

.btn {
  background-color: #292c58;
}

.shdw {
  box-shadow: 0 2px 4px 0 rgba(245, 240, 225, 0.8),
    0 6px 20px 0 rgba(245, 240, 225, 0.8);
  border-radius: 5px;
}

.fade {
  opacity: 0.5;
  transition: opacity 0.05s ease-in-out;
  -moz-transition: opacity 0.05s ease-in-out;
  -webkit-transition: opacity 0.05s ease-in-out;
}

.fade:hover {
  opacity: 1;
}

@media screen and (max-width: 1023px) {
  .wdt {
    width: 100%;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}

@media screen and (min-width: 1024px) {
  .wdt {
    width: 500px;
    margin: auto;
    /* background-color: #F5F0E1; */
  }
}
</style>
